(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-customizable-template"]) return;
  try {
    
    // Get seconds bewtween days
    var currentDate = new Date();
    var currentDateTimestamp = new Date().getTime();
    var countDownDate = $('#dayEndCountdown').val() + "-" + $('#monthEndCountdown').val() + "-" + $('#yearEndCountdown').val() + " 00:01"; 
    var dateTimeParts = countDownDate.split(' '),
        timeParts = dateTimeParts[1].split(':'),
        dateParts = dateTimeParts[0].split('-');
    var countDownDateFormat = new Date(dateParts[2], parseInt(dateParts[1], 10) - 1, dateParts[0], timeParts[0], timeParts[1]);
    var hoursBetweenDates = Math.abs(countDownDateFormat - currentDate) / 36e5;
    var secondsBetweenDates = hoursBetweenDates*60*60;
    var ninetyEightDaysInSeconds = 8467200;
    if(secondsBetweenDates > ninetyEightDaysInSeconds) {
        secondsBetweenDates = ninetyEightDaysInSeconds;
    }
    // Countdown
    var clock;
    var countdownLang;
    var countdownEndMsg;
    if($('#langCountdown').val() == 'fr') {
    	countdownLang = 'fr';
    	countdownEndMsg = 'L\'offre se termine dans quelques secondes...';
    } else {
    	countdownLang = 'en';
    	countdownEndMsg = 'Only a few seconds left...';
    }
    clock = $('#countdownv2ot').FlipClock({
        clockFace: 'DailyCounter',
        autoStart: false,
        language: countdownLang,
        callbacks: {
            stop: function() {
                $('.sales-loading-bar-v').css({"background-color":"#ff0000","width":"100%","border-radius":"10px"});
                $('.product-form__item--submit').hide();
                $('.countdown-over').show();
            }
        }
    });
    // Check if date is before today
    if (countDownDateFormat < new Date()) {
        secondsBetweenDates = 0;
    }             
    // Set Time
    clock.setTime(secondsBetweenDates);
    clock.setCountdown(true);
    clock.start();
                                 

// random views
if($('#liveViewRange').length > 0) {
    setInterval(function() {
        var randomNumberViews = Math.floor((Math.random() * $('#liveViewRange').val()) + 2);
        $('#peoplenb').text(randomNumberViews);
    }, 6000);
}

// random order
if($('#liveOrderRange').length > 0) {
    setInterval(function() {
        var randomNumberOrder = Math.floor((Math.random() * $('#liveOrderRange').val()) + 2);
        $('#ordernb').text(randomNumberOrder);
    }, 10000);
}

// random stock + cookie
if($('#liveStockRange').length > 0) {
	function getCookie(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }
  	if(getCookie('cookiestock'+$('#productHandle').val()) == null) {
        var randomNumberStock = Math.floor((Math.random() * $('#liveStockRange').val()) + 1);
        var dateCurrent = new Date();
        var dateNextWeek = new Date(dateCurrent.getTime() + 7 * 24 * 60 * 60 * 1000);
        dateNextWeek = dateNextWeek.toUTCString();
        document.cookie = 'cookiestock'+$('#productHandle').val()+'='+randomNumberStock+'; expires='+dateNextWeek+'; path=/'; 
        $('#stockleftnb').text(randomNumberStock);
    } else {
    	var getCookieProduct = getCookie('cookiestock'+$('#productHandle').val());
      	$('#stockleftnb').text(getCookieProduct);
    }
}

// Display save price percent
if($('#sectionId').length > 0) {
    function updateSavePrice() {
      // check if saveprice is OK
      window.setInterval(function(){
        var productCurrentPrice = $('#ProductPrice-'+$('#sectionId').val()).text().trim();
        var productCurrentPriceDot = productCurrentPrice.replace(",",".");
        productCurrentPriceCut = parseFloat(productCurrentPriceDot.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)[0]).toFixed(2);
        var productCurrentComparePrice = $('#ComparePrice-'+$('#sectionId').val()).text().trim();
        var productCurrentComparePriceDot = productCurrentComparePrice.replace(",",".");
        productCurrentComparePriceCut = parseFloat(productCurrentComparePriceDot.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)[0]).toFixed(2);
        var saveAmount = productCurrentComparePriceCut - productCurrentPriceCut;
        saveAmount = saveAmount.toFixed(2);
        var savePercent = saveAmount*100/productCurrentComparePriceCut;
        savePercent = savePercent.toFixed(0);
        if(/[,\.]/.test(productCurrentPrice)) {
            var priceWithCurrency = productCurrentPrice.match(/-?\d+\:?(\.|,)\d+/)[0];
        } else {
            var priceWithCurrency = productCurrentPrice;
        }
        var saveString = productCurrentPrice.replace(priceWithCurrency, saveAmount);
        $('#variantsaveprice').text(saveString);
        $('#variantpercent').text(savePercent);
      }, 100);
    }
    updateSavePrice(); 
    $(".selector-wrapper select").change(function(){
      setTimeout(function() {
        updateSavePrice();
      }, 100);
    });
}

  } catch(e) { console.error(e); }
})();
})();
